import React, { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { CepInput } from '../OscInputs/CepInput'
import { OscInput } from '../OscInputs/OscInput'
import { Location } from '../../../types/Location'

export const LocationFields = ({locationOld}:Props) => {

    const [cep,setCep] = useState<string>(locationOld ? locationOld.code : "")
    const [location,setLocation] = useState<Location|undefined>(locationOld ? locationOld : undefined)

    const getLocation = useCallback(async ()=>{
        await axios.get(`https://ws.apicep.com/cep/${cep}.json/`).then(res => {
            if(res.data.status === 404) return alert('cep não encontrado');
            setLocation(res.data);
            setCep(res.data.code)
        }).catch(console.log);
    },[cep])

    const handleCep = useCallback((e:HTMLInputElement)=>{
            if(e.value.length > 8) return
            setCep(e.value.replace('-',''))
            setLocation(undefined)
    },[])

    useEffect(()=>{
        if(cep.length === 8)
            getLocation()
        if(locationOld){
            setLocation(locationOld)
        } 
    },[cep,getLocation,locationOld])

    return(
        <div className='mt-6 grid gap-x-6 gap-y-2 grid-cols-1 md:grid-cols-2 text-gray-800 '>
          <CepInput label={"CEP"} name='location[0][code]' value={cep} onChange={e=>handleCep(e.target)} required  />
          <OscInput label={"Rua"}  name={"location[0][address]"} defaultValue={location?.address ? location.address :'' }
                    className="pointer-events-none" necessary required  />
          <OscInput label={"Bairro"} name={"location[0][district]"} defaultValue={location?.district ? location.district : ''}
                    className="pointer-events-none"  necessary required />
          <OscInput label={"Estado"} name={"location[0][state]"}defaultValue={location?.state ? location.state : ''}
                    className="pointer-events-none" necessary required />
          <OscInput label={"Cidade"} name={"location[0][city]"} defaultValue={location?.city ? location.city : ""}
                    className="pointer-events-none" necessary required  />
          <OscInput label={"Número"} name={"location[0][number]"} necessary required defaultValue={locationOld && locationOld.number} />
          <OscInput label={"Complemento"} name={"location[0][complement]"} defaultValue={locationOld && locationOld.complement} />
        </div>
    )
}

interface Props {
    locationOld?: Location
}